import { useContext } from "react";
import {
  AiFillDislike,
  AiFillLike,
  AiOutlineDislike,
  AiOutlineLike,
} from "react-icons/ai";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { useComment, useCommentValue } from "..";
import { usePost, usePostValue } from "../../..";
import { DP } from "../../../../../common/types";
import { ProfileContext } from "../../../../../context/profileContext";
import { useStateReducer } from "../../../../../hooks/useStateReducer";
import { fetchCommentLike } from "../../../api";
import { calcLikeColor } from "../../../helpers";

interface IState {
  isLoading: boolean;
  currentReaction: "like" | "dislike" | "none";
}

interface Props extends DP {}

const LikeArea = (props: Props) => {
  const [state, setState] = useStateReducer({
    isLoading: false,
    // currentReaction:
  });
  const profile = useContext(ProfileContext);

  const { setOne: setCommentOne, set: setComment } = useComment();

  const comment = useCommentValue((s) => s.comment);

  const userLikeType = comment.reactions.find(
    (el) => el.userId == profile?.user?._id
  );

  const handleLike = (reaction: "like" | "dislike") => async () => {
    setState({ isLoading: true });
    setComment({ isEditing: false });
    fetchCommentLike(reaction, comment._id)
      .then(({ status, data }) => {
        if (status == 200) {
          setCommentOne("comment", (v) => ({
            ...v,
            reactions: data.reactions,
            rating: data.rating,
          }));
        }
      })
      .finally(() => {
        setState({ isLoading: false });
      });
  };

  return (
    <LikesWrapper className={props.className}>
      <LikeButton disabled={state.isLoading} onClick={handleLike("like")}>
        {userLikeType?.reaction === "like" ? <AiFillLike /> : <AiOutlineLike />}
      </LikeButton>
      <LikesCount color={calcLikeColor(comment.rating)}>
        {comment.rating}
      </LikesCount>
      <DislikeButton disabled={state.isLoading} onClick={handleLike("dislike")}>
        {userLikeType?.reaction === "dislike" ? (
          <AiFillDislike />
        ) : (
          <AiOutlineDislike />
        )}
      </DislikeButton>
    </LikesWrapper>
  );
};

const LikesWrapper = styled.div(() => [
  tw`mb-auto flex-col items-center text-[0.38rem]`,
]);

const LikesCount = styled.div(({ color }: { color: "green" | "red" }) => [
  css`
    text-align: center;
    color: ${color};
  `,
]);

const LikeButton = styled.button(() => [
  tw`cursor-pointer disabled:(opacity-20)`,
  css`
    svg {
      margin: 0.125em;
    }
  `,
]);

const DislikeButton = styled.button(() => [
  tw`cursor-pointer disabled:(opacity-20)`,
  css`
    svg {
      margin: 0.125em;
    }
  `,
]);

export default styled(LikeArea)``;
